import { Outlet, createRootRoute, useRouterState } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import { Suspense } from 'react'
import { TopBar } from '@/components/atoms'
import { LimitExceededModal } from '@/components/modals'
import { AuthBootstrap } from '@/features/auth/AuthBootstrap'

const HIDE_TOPBAR_ON = ['/auth', '/']

function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const hideTopbar = HIDE_TOPBAR_ON.some((p) => pathname === p || (p !== '/' && pathname.startsWith(p)))
  return (
    <div className="min-h-screen flex flex-col bg-bg text-text">
      <AuthBootstrap />
      {!hideTopbar && <TopBar />}
      <main className="flex-1 flex flex-col min-w-0">
        <Outlet />
      </main>
      <LimitExceededModal />
      {import.meta.env.DEV && (
        <Suspense>
          <TanStackRouterDevtools position="bottom-right" />
        </Suspense>
      )}
    </div>
  )
}

export const Route = createRootRoute({
  component: RootLayout,
})
